import React from "react";

interface ContainerListProps {
  containers: any[];
  completeContainers: string[];
  handleCheckboxChange: (containerId: string) => void;
}

export const ContainerList: React.FC<ContainerListProps> = ({
  containers,
  completeContainers,
  handleCheckboxChange,
}) => {
  return (
    <div className="rounded-lg border p-4">
      <h3 className="mb-2 text-lg font-medium">
        Select the container(s) that will hold COMPLETED work
      </h3>
      <ul className="space-y-2">
        {[...(containers ?? [])]
          .sort((a, b) => {
            const nameA = (a.displayName || a.id).toLowerCase();
            const nameB = (b.displayName || b.id).toLowerCase();
            return nameA.localeCompare(nameB);
          })
          .map((container) => (
            <li key={container.id} className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={completeContainers.includes(container.id)}
                onChange={() => handleCheckboxChange(container.id)}
                id={`container-checkbox-${container.id}`}
              />
              <label
                htmlFor={`container-checkbox-${container.id}`}
                className="cursor-pointer text-white"
              >
                {container.displayName || container.id}
              </label>
            </li>
          ))}
      </ul>
    </div>
  );
};
